import axios from 'axios';
import {
  GET_USER_NATIONAL_ID_REQUEST,
  GET_USER_NATIONAL_ID_SUCCESS,
  GET_USER_NATIONAL_ID_FAILURE,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';

export const getNationalId = () => async dispatch => {
  try {
    dispatch({
      type: GET_USER_NATIONAL_ID_REQUEST
    });

    const res = await axios.get('/users/informations/national-id');

    dispatch({
      type: GET_USER_NATIONAL_ID_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_USER_NATIONAL_ID_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
